import React, { useContext, useEffect, useMemo } from 'react';
import useMenuTitle from '../hooks/useMenuTitle';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { UserContext } from '../contexts/UserContext';
import ViewSiteServices from '../modules/DashboardCustomerUnsecured/ViewSiteServices';
import Status from '../modules/DashboardCustomerUnsecured/Status';
import useMenuSecondary from '../hooks/useMenuSecondary';
import DispatchHistory from '../modules/status/DispatchHistory/DispatchHistory';

function DashboardCustomerUnsecured() {
  useMenuTitle("Dashboard")

  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const location = useLocation();
  const page = searchParams.get("page")


  const {userDetails} = useContext(UserContext);
  const {isMobile} = userDetails; //reserved for future mobile 

  console.log("I AM THE LOUP SOURCE")

  
useEffect(() => {
  if (!page) {
    navigate("/dashboard", { replace: true, state: location.state });
  }
}, [page, navigate, location.state]);

  
const menuView = useMemo(() => ({
  title: "View",
  submenu: [
    { title: "Status", url: "/dashboard" },
    { title: "Site Services - Miljo", url: "/dashboard?page=siteservices" },
    { title: "Dispatch History", url: "/dashboard?page=dsphistory" },
  ],
}), []);

  useMenuSecondary(menuView);
  return (
    <>
      {page === "siteservices" ? (<ViewSiteServices />) : 
      page === "dsphistory" ? (<DispatchHistory />) : <Status />}
    </>
  );
}

export default DashboardCustomerUnsecured;